import {
    BaseService
} from "./BaseService";
import {
    SnackBarModule
} from "../modules/SnackBarModule";

export const EmitirRelatorioService = {

    async emitirRelatorio(rota, postData) {
        const response = await BaseService.downloadItemPost(`relatorios/ferias/${rota}`,postData);

        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }


        SnackBarModule("Baixado com sucesso", "success");
        return true;
    },

    async definirPermissaoEmissao(postData) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `relatorios/permissao`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return true;
    },

    async pegarPermissaoPerfil(id_perfil){
        const response = await BaseService.fetchResponseFromAPIGet(
            `relatorios/permissao/${id_perfil}`);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return response.content;
    }
}